import React, {useEffect} from 'react';
import {motion, useAnimation, Variants} from 'framer-motion';

const phoneWidth = 119; // Width of the phone
const phoneHeight = 243; // Height of the phone
const pathLength = phoneHeight * 2 + phoneWidth * 2; // Calculate the total length of the path

const phoneVariants: Variants = {
  initial: {
    strokeDasharray: `${pathLength} ${pathLength}`,
    strokeDashoffset: pathLength,
  },
  animate: {
    strokeDashoffset: 0,
    transition: {
      duration: 2, // Animation duration in seconds
      ease: 'easeInOut', // Animation easing
    },
  },
};

const outerCircleVariants: Variants = {
  initial: {
    opacity: 0,
    strokeDashoffset: '2 1',
  },
  animate: {
    opacity: 1,
    strokeDashoffset: 0,
    transition: {
      duration: 1.5,
      delay: 1.5,
      ease: 'easeInOut',
    },
  },
};

const innerCircleVariants: Variants = {
  initial: {
    opacity: 0,
    pathLength: 0,
  },
  animate: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 1.5,
      delay: 1.5,
      ease: 'easeInOut',
    },
  },
};

const barVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0,
  },
  animate: {
    opacity: 1,
    scale: -1,
    transition: {
      duration: 1,
      delay: 0.3,
      ease: 'easeInOut',
    },
  },
};

const boltVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0,
  },
  animate: {
    opacity: 1,
    scale: -1,
    transition: {
      duration: 0.3,
      delay: 1.7,
      ease: 'easeInOut',
    },
  },
};

const PhoneWallbox = () => {
  const phone = useAnimation();
  const bar = useAnimation();
  const circleOuter = useAnimation();
  const circleInner = useAnimation();
  const bolt = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      setTimeout(() => {
        // Start the animation after 2 seconds
      }, 2000);
      phone.start('animate');
      bar.start('animate');
      circleOuter.start('animate');
      circleInner.start('animate');
      bolt.start('animate');
    };
    sequence();
  }, [bar, bolt, circleInner, circleOuter, phone]);

  return (
    <svg
      width="151"
      height="244"
      viewBox="0 0 151 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{margin: '0 auto', paddingRight: 24}}
    >
      <motion.rect
        x="31.5"
        y="0.5"
        width={phoneWidth}
        height={phoneHeight}
        rx="11.5"
        stroke="white"
        strokeWidth="1" // Adjust the stroke width as needed
        initial="initial"
        animate={phone}
        variants={phoneVariants}
        id="phone"
      />
      <motion.path
        d="M31.5 38.1294C39.1482 34.2109 47.8159 32 57 32C87.9279 32 113 57.0721 113 88C113 118.928 87.9279 144 57 144C47.8159 144 39.1482 141.789 31.5 137.871"
        stroke="white"
        strokeWidth="2"
        id="innerCircle"
        initial="initial"
        variants={innerCircleVariants}
        animate={circleInner}
      />
      <motion.path
        d="M57 144C47.8159 144 39.1482 141.789 31.5 137.871C13.3925 128.593 1 109.744 1 88C1 66.2562 13.3925 47.4067 31.5 38.1294"
        stroke="white"
        strokeDasharray="2"
        id="outerCircle"
        initial="initial"
        variants={outerCircleVariants}
        animate={circleOuter}
      />
      <motion.path
        id="bolt"
        d="M65.2687 85.5723H58.8477L61.3948 76L49 90.754H55.421L52.8739 100.326L65.2687 85.5723Z"
        fill="white"
        initial="initial"
        variants={boltVariants}
        animate={bolt}
      />
      <motion.path
        d="M76 12H106"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
        id="bar"
        initial="initial"
        variants={barVariants}
        animate={bar}
      />
    </svg>
  );
};

export default PhoneWallbox;
